module.exports = {
  changeChargeNo: 'Регистрационный номер заявки',
  changeReason: 'Причина изменения',
  state: 'Статус заявки',
  jobNo: 'Номер операции',
  customerId: 'Заказчик',
  receivable: 'Тип расхода',
  dateCreated: 'Время подачи заявки',
  createdBy: 'Заявитель',
  judgeDutyResult: 'Результат проверки ответственности',
  judgeDutyDate: 'Время проверки ответственности',
  judgeDutyBy: 'Проверяющий ответственность',
  businessAuditResult: 'Результат коммерческой проверки',
  businessAuditReason: 'Причина отказа',
  businessAuditDate: 'Время коммерческой проверки',
  businessAuditBy: 'Коммерческий проверяющий',
  judgeClosedResult: 'Решение о закрытии счета',
  judgeClosedDate: 'Время решения о закрытии счета',
  judgeClosedBy: 'Ответственный за закрытие счета',
  returnReason: 'Причина возврата',
  returnDate: 'Время возврата',
  returnBy: 'Инициатор возврата',
  remarks: 'Примечание',
  details: 'Сравнение до и после изменения',
  revoke: 'Отозвать заявку',
  return: 'Вернуть',
  judgeDuty: 'Проверка ответственности',
  businessAudit: 'Коммерческая проверка',
  judgeClosed: 'Решение о закрытии счета',
  exportDetail: 'Экспорт детализации',
  tabJudgeDuty: 'Ожидает проверки ответственности',
  tabBusinessAudit: 'Ожидает коммерческой проверки',
  tabJudgeClosed: 'Ожидает решения о закрытии счета',
  tabManagerReview: 'Ожидает проверки менеджером',
  tabAll: 'Все',
  dateCreatedDay: 'Дата подачи заявки',
  judgeDutyDateDay: 'Дата проверки ответственности',
  businessAuditDateDay: 'Дата коммерческой проверки',
  judgeClosedDateDay: 'Дата решения о закрытии счета',
  applyChangeCharge: 'Заявка на изменение расхода',
  applyAddCharge: 'Заявка на добавление расхода',
  applyDeleteCharge: 'Заявка на удаление расхода',
  showApplyChangingCharge: 'Просмотр проверки изменения расхода',
  ChangeTheChargesInTheExpenseReview: 'Расходы на проверке изменения',
  actionType: 'Тип заявки',
  confirmApplyDeleteCharge: 'Подтверждаете удаление этого расхода?',
  changeReasonCannotBeNull: 'Причина изменения не может быть пустой.',
  changeReasonIsTooLong: 'Длина причины изменения не должна превышать 100 символов.',
  judgeDutyMessage: 'Несет ли оператор ответственность за данное изменение расхода?',
  judgeDutyYes: 'Ответственный',
  judgeDutyNo: 'Не ответственный',
  businessAuditMessage: 'Согласны ли вы на изменение расходов?',
  businessAuditAgree: 'Согласен',
  businessAuditRefuse: 'Отказать',
  businessAuditReasonNotNull: 'Укажите причину отказа',
  judgeClosedMessage: 'Это изменение расходов до или после закрытия счета?',
  judgeClosedBefore: 'До закрытия счета',
  judgeClosedAfter: 'После закрытия счета',
  returnMessage: 'Эта заявка вернется в исходное состояние',
  returnMessageConfirm: 'Подтверждаете возврат?',
  returnReasonNotNull: 'Укажите причину возврата',
  revokeMessage: 'Можно отозвать только неподтвержденные заявки, проверьте',
  revokeMessageConfirm: 'После отмены восстановление невозможно, подтверждаете отмену?',
  modifyBefore: 'До изменения',
  modifyAfter: 'После изменения',
  estimateProfit: 'Прогнозируемая прибыль по всему счету:',
  generateByContract: 'Импортировать договорную цену',
  generateByContractConfirm: 'Подтверждаете импорт договорной цены?',
  JudgmentResult: 'Результат определения ответственности',
  ChangeCharge: 'Изменение расходов',
  OnlyRejectedApplicationFormsCanBeCopied: 'Можно копировать только отклоненные заявки',
  JudgeBeforeAndAfterAccountClosing: 'Определить до или после закрытия счета',
  FeesIncurred: 'Возникновение расходов',
  updateSuccess: 'Курс валюты для необработанных расходов по [{0}] успешно обновлен',
  exchangeRates: 'Диапазон курса изменился, обновить курс для расходов?',
  exchangeRates2: 'Диапазон курса основного счета изменился, обновить курс для расходов по подсчетам?',
  chargeLanguage: 'Языковое описание',
  costDescription: 'Описание расходов'
}
